import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The `}<inlineCode parentName="p">{`capture()`}</inlineCode>{` method has an optional argument `}<inlineCode parentName="p">{`sendFeatureFlags`}</inlineCode>{`, which is set to `}<inlineCode parentName="p">{`false`}</inlineCode>{` by default. This parameter controls whether feature flag information is sent with the event.`}</p>
    <h4 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h4>
    <p>{`Setting `}<inlineCode parentName="p">{`sendFeatureFlags`}</inlineCode>{` to `}<inlineCode parentName="p">{`true`}</inlineCode>{` will include feature flag information with the event:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-node"
      }}>{`client.capture({
    distinctId: 'distinct_id_of_your_user',
    event: 'event_name',
    sendFeatureFlags: true,
})
`}</code></pre>
    <h4 {...{
      "id": "advanced-usage-v550"
    }}>{`Advanced usage (v5.5.0+)`}</h4>
    <p>{`As of version 5.5.0, `}<inlineCode parentName="p">{`sendFeatureFlags`}</inlineCode>{` can also accept an options object for more granular control:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-node"
      }}>{`client.capture({
    distinctId: 'distinct_id_of_your_user',
    event: 'event_name',
    sendFeatureFlags: {
        onlyEvaluateLocally: true,
        personProperties: { plan: 'premium' },
        groupProperties: { org: { tier: 'enterprise' } }
    }
})
`}</code></pre>
    <h4 {...{
      "id": "performance-considerations"
    }}>{`Performance considerations`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`With local evaluation`}</strong>{`: When `}<a parentName="p" {...{
            "href": "/docs/feature-flags/local-evaluation"
          }}>{`local evaluation`}</a>{` is configured, setting `}<inlineCode parentName="p">{`sendFeatureFlags: true`}</inlineCode>{` will `}<strong parentName="p">{`not`}</strong>{` make additional server requests. Instead, it uses the locally cached feature flags, and it provides an interface for including person and/or group properties needed to evaluate the flags in the context of the event, if required.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Without local evaluation`}</strong>{`: PostHog will make an additional request to fetch feature flag information before capturing the event, which adds delay.`}</p>
      </li>
    </ul>
    <h4 {...{
      "id": "breaking-change-in-v550"
    }}>{`Breaking change in v5.5.0`}</h4>
    <p>{`Prior to version 5.5.0, feature flags were automatically sent with events when using local evaluation, even when `}<inlineCode parentName="p">{`sendFeatureFlags`}</inlineCode>{` was not explicitly set. This behavior has been `}<strong parentName="p">{`removed`}</strong>{` in v5.5.0 to be more predictable and explicit.`}</p>
    <p>{`If you were relying on this automatic behavior, you must now explicitly set `}<inlineCode parentName="p">{`sendFeatureFlags: true`}</inlineCode>{` to continue sending feature flags with your events.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      